"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var styles = tslib_1.__importStar(require("./BulletPagination.style"));

var PaginationArrow_1 = tslib_1.__importDefault(require("./PaginationArrow"));

var MAX_BULLET_SLIDE = 20;

function BulletPagination(_ref) {
  var activeIndex = _ref.activeIndex,
      slideLength = _ref.slideLength,
      dispatchActiveIndex = _ref.dispatchActiveIndex;
  var isRemainLeft = activeIndex !== 0;
  var isRemainRight = activeIndex !== slideLength - 1;
  var leftArrowClick = react_1.useCallback(function (event) {
    event.stopPropagation();
    dispatchActiveIndex(activeIndex - 1);
  }, [activeIndex]);
  var rightArrowClick = react_1.useCallback(function (event) {
    event.stopPropagation();
    dispatchActiveIndex(activeIndex + 1);
  }, [activeIndex]);
  return jsx_runtime_1.jsxs(react_1.Fragment, {
    children: [jsx_runtime_1.jsx("ul", Object.assign({
      css: styles.container
    }, {
      children: Array(slideLength).slice(0, MAX_BULLET_SLIDE).fill(0).map(function (_v, index) {
        return jsx_runtime_1.jsx("li", Object.assign({
          css: [styles.bullet, index === activeIndex && styles.active]
        }, {
          children: jsx_runtime_1.jsx("span", {}, void 0)
        }), index);
      })
    }), void 0), jsx_runtime_1.jsx(PaginationArrow_1.default, {
      isRemainLeft: isRemainLeft,
      isRemainRight: isRemainRight,
      leftArrowClick: leftArrowClick,
      rightArrowClick: rightArrowClick
    }, void 0)]
  }, void 0);
}

exports.default = BulletPagination;